module.exports = __webpack_public_path__ + "img/EventManager.faf5fd25.svg";